import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Autocomplete, Backdrop, Box, Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import Checkbox from '@mui/material/Checkbox';
import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import Error from '../../../components/error/error';
import pdfIcon from '../../../images/pdfIcon.png';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, convertToObjectArray, dBillAPI, disconnectionDetails, getMeterType, getNextMonth, getPhase, getPreviousMonth, getRightSideNumbers, handleFileUpload, isImage, isPdf, subDivAPI, subdivisionName } from '../../../services/Functions';
import { documentExtensions, imageExtensions, portalName } from '../../../utils/PortalName';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import { useSelector } from 'react-redux';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import UploadSampleImage from '../../../images/UploadImage.png';
import mepcologo from "../../../images/mepcoLogo.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { netMeterClaimedLabels, singlePhaseClaimedLabels, singlePhaseLabels, threePhaseClaimedLabels, threePhaseLabels } from '../../../utils/PortalName';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';

const MeterReadingCorrectionForm = () => {

  //#region constants
  const refNoSinglePhase = '01151715000404'
  const refNoThreePhase = '02151722187800'
  const refNoThreePhaseMDI = '27151710924700'
  const refNoNetMeter = '27151250363540'

  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );

  const initialValues = {
    // Classification group Initial Values
    iv_search_by: 'referenceNo',
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    iv_other_remarks: "",
    // meter details field
    iv_meter_phase: '',
    iv_meter_no: '',
    iv_meter_type: '',
    iv_connection_type: '',
    // reading details field
    iv_billing_month: '',

    //single phase readings
    iv_previous_reading_single_phase: '',
    iv_current_reading_single_phase: '',
    iv_claimed_reading_single_phase: '',

    //3 phase readings
    iv_previous_off_peak_three_phase: '',
    iv_previous_peak_three_phase: '',
    iv_current_off_peak_three_phase: '',
    iv_current_peak_three_phase: '',
    iv_claimed_off_peak_three_phase: '',
    iv_claimed_peak_three_phase: '',

    // simple net meter
    iv_previous_offpeak_import: '',
    iv_previous_peak_import: '',
    iv_previous_offpeak_export: '',
    iv_previous_peak_export: '',
    iv_current_offpeak_import: '',
    iv_current_peak_import: '',
    iv_current_offpeak_export: '',
    iv_current_peak_export: '',
    iv_claimed_offpeak_import: '',
    iv_claimed_peak_import: '',
    iv_claimed_offpeak_export: '',
    iv_claimed_peak_export: '',

    //3 phase mdi readings
    iv_previous_kwh_off_peak_three_phase_mdi: '',
    iv_previous_kwh_peak_three_phase_mdi: '',
    iv_previous_kVArh_off_peak_three_phase_mdi: '',
    iv_previous_kVArh_peak_three_phase_mdi: '',
    iv_previous_mdi_off_peak_three_phase_mdi: '',
    iv_previous_mdi_peak_three_phase_mdi: '',
    iv_current_kwh_off_peak_three_phase_mdi: '',
    iv_current_kwh_peak_three_phase_mdi: '',
    iv_current_kVArh_off_peak_three_phase_mdi: '',
    iv_current_kVArh_peak_three_phase_mdi: '',
    iv_current_mdi_off_peak_three_phase_mdi: '',
    iv_current_mdi_peak_three_phase_mdi: '',
    iv_claimed_kwh_off_peak_three_phase_mdi: '',
    iv_claimed_kwh_peak_three_phase_mdi: '',
    iv_claimed_kVArh_off_peak_three_phase_mdi: '',
    iv_claimed_kVArh_peak_three_phase_mdi: '',
    iv_claimed_mdi_off_peak_three_phase_mdi: '',
    iv_claimed_mdi_peak_three_phase_mdi: '',

    // 3 phase mdi net meter readings
    iv_previous_kWh_off_peak_three_phase_mdi_import: '',
    iv_previous_kWh_peak_three_phase_mdi_import: '',
    iv_previous_kVArh_off_peak_three_phase_mdi_import: '',
    iv_previous_kVArh_peak_three_phase_mdi_import: '',
    iv_previous_mdi_off_peak_three_phase_mdi_import: '',
    iv_previous_mdi_peak_three_phase_mdi_import: '',
    iv_previous_kWh_off_peak_three_phase_mdi_export: '',
    iv_previous_kWh_peak_three_phase_mdi_export: '',
    iv_previous_kVArh_off_peak_three_phase_mdi_export: '',
    iv_previous_kVArh_peak_three_phase_mdi_export: '',
    iv_previous_mdi_off_peak_three_phase_mdi_export: '',
    iv_previous_mdi_peak_three_phase_mdi_export: '',
    iv_current_kWh_off_peak_three_phase_mdi_import: '',
    iv_current_kWh_peak_three_phase_mdi_import: '',
    iv_current_kVArh_off_peak_three_phase_mdi_import: '',
    iv_current_kVArh_peak_three_phase_mdi_import: '',
    iv_current_mdi_off_peak_three_phase_mdi_import: '',
    iv_current_mdi_peak_three_phase_mdi_import: '',
    iv_current_kWh_off_peak_three_phase_mdi_export: '',
    iv_current_kWh_peak_three_phase_mdi_export: '',
    iv_current_kVArh_off_peak_three_phase_mdi_export: '',
    iv_current_kVArh_peak_three_phase_mdi_export: '',
    iv_current_mdi_off_peak_three_phase_mdi_export: '',
    iv_current_mdi_peak_three_phase_mdi_export: '',
    iv_claimed_kWh_off_peak_three_phase_mdi_import: '',
    iv_claimed_kWh_peak_three_phase_mdi_import: '',
    iv_claimed_kVArh_off_peak_three_phase_mdi_import: '',
    iv_claimed_kVArh_peak_three_phase_mdi_import: '',
    iv_claimed_mdi_off_peak_three_phase_mdi_import: '',
    iv_claimed_mdi_peak_three_phase_mdi_import: '',
    iv_claimed_kWh_off_peak_three_phase_mdi_export: '',
    iv_claimed_kWh_peak_three_phase_mdi_export: '',
    iv_claimed_kVArh_off_peak_three_phase_mdi_export: '',
    iv_claimed_kVArh_peak_three_phase_mdi_export: '',
    iv_claimed_mdi_off_peak_three_phase_mdi_export: '',
    iv_claimed_mdi_peak_three_phase_mdi_export: '',

    //new images fields
    iv_off_peak_import: '',
    iv_off_peak_export: '',
    iv_peak_import: '',
    iv_peak_export: '',
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_applicant_cnic_document_front: null,
    iv_applicant_cnic_document_back: null,

    iv_tariff_description: '',
    iv_tariff_code: '',
  }

  const { token, code: userCode, name: userName, userId, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)
  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedAdminCompanyCode,
  );
 const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const mdiTrifs = [
    { tariffCode: '05', tariffDesc: 'A - 2b(05)' },
    { tariffCode: '06', tariffDesc: 'A - 2c(06)T' },
    { tariffCode: '09', tariffDesc: 'B1b(09)T' },
    { tariffCode: '10', tariffDesc: 'B2a(10)' },
    { tariffCode: '11', tariffDesc: 'B2a(11)' },
    { tariffCode: '12', tariffDesc: 'B2b(12)T' },
    { tariffCode: '13', tariffDesc: 'B3(13)' },
    { tariffCode: '14', tariffDesc: 'B3(14)T' },
    { tariffCode: '15', tariffDesc: 'K - 2(15)' },
    { tariffCode: '16', tariffDesc: 'B4(16)' },
    { tariffCode: '17', tariffDesc: 'B4(17)T' },
    { tariffCode: '19', tariffDesc: 'C - 1a(19)' },
    { tariffCode: '25', tariffDesc: 'C - 1b(25)' },
    { tariffCode: '26', tariffDesc: 'C - 1c(26)T' },
    { tariffCode: '28', tariffDesc: 'C - 2a(28)' },
    { tariffCode: '29', tariffDesc: 'C - 2b(29) T' },
    { tariffCode: '35', tariffDesc: 'K - 1a(35)' },
    { tariffCode: '36', tariffDesc: 'K - 1b(36)T' },
    { tariffCode: '37', tariffDesc: 'C - 3a(37)' },
    { tariffCode: '38', tariffDesc: 'C - 3b(38)T' },
    { tariffCode: '45', tariffDesc: 'D - 1b(45)T' },
    { tariffCode: '50', tariffDesc: 'D - 2b(50)T' },
    { tariffCode: '51', tariffDesc: 'D - 2b(51)T' },
    { tariffCode: '53', tariffDesc: 'D - 2b(53)T' },
    { tariffCode: '54', tariffDesc: 'D - 2b(54)T' },
    { tariffCode: '59', tariffDesc: 'C - 1a(59)' },
    { tariffCode: '60', tariffDesc: 'C - 2a(60)' },
    { tariffCode: '61', tariffDesc: 'C - 3a(61)' },
    { tariffCode: '82', tariffDesc: 'I(82)' },
    { tariffCode: '83', tariffDesc: 'J - 1a(83)' },
    { tariffCode: '84', tariffDesc: 'J - 1b(84) T' },
    { tariffCode: '85', tariffDesc: 'J - 2a(85)' },
    { tariffCode: '86', tariffDesc: 'J - 2b(86)' },
    { tariffCode: '87', tariffDesc: 'J - 2c(87) T' },
    { tariffCode: '88', tariffDesc: 'J - 2d(88) T' },
    { tariffCode: '89', tariffDesc: 'J - 3a(89)' },
    { tariffCode: '90', tariffDesc: 'J - 3b(90)' },
    { tariffCode: '91', tariffDesc: 'J - 3c(91) T' },
    { tariffCode: '92', tariffDesc: 'J - 3d(92) T' },
    { tariffCode: 'RR', tariffDesc: 'GLRGLRLG' }
  ]

  const inputStyle = {
    color: 'white', // Change text color to white
    paddingRight: '65px', // Add padding to make space for the adornment
    border: '1px solid #ccc', // Optional: Add border styling
    borderRadius: '4px', // Optional: Border radius
    width: 'auto', // Optional: Set a fixed width for the input
    minWidth: '80%'
    // marginTop: '-50px'
    // height: '40px', // Optional: Set height for better appearance
  };

  const adornmentStyle = {
    position: 'absolute',
    right: '0px', // Position from the right
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'white', // Change adornment color to white
    padding: '0 8px',
  };

  const mCStatusBarArray = [{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  },
  {
    title1: 'COPY OF',
    title2: 'BILL',
    status: 0
  },
  {
    title1: `APPLICANT'S CNIC`,
    title2: '(OPTIONAL)',
    status: 0
  }];

  const fileInputRefOffPeakImport = useRef(null);
  const fileInputRefPeakImport = useRef(null);
  const fileInputRefOffPeakExport = useRef(null);
  const fileInputRefPeakExport = useRef(null);
  //#endregion

  //#region states
  const [isCheckedImagesAreBlur, setIsCheckedImagesAreBlur] = useState(false);
  const [isCheckedOthers, setIsCheckedOthers] = useState(false);

  // Classification Group States
  const [complaintId, setComplaintId] = useState();
  const [meterReadingPopUp, setMeterReadingPopUp] = useState(false);
  const [error, setError] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [address, setAddress] = useState('');
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();

  const [connectionType, setConnectionType] = useState('');
  const [otherRemarks, setOtherRemarks] = useState('');
  const [meterImage1, setMeterImage1] = useState()
  const [meterImage2, setMeterImage2] = useState()
  const [meterImage3, setMeterImage3] = useState()
  const [meterImage4, setMeterImage4] = useState()
  const [tariff, setTariff] = useState()
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [isCheckedImagesDoNotMatch, setIsCheckedImagesDoNotMatch] = useState(false);

  const [offPeakImport, setOffPeakImport] = useState()
  const [offPeakExport, setOffPeakExport] = useState()
  const [peakImport, setPeakImport] = useState()
  const [peakExport, setPeakExport] = useState()
  const [offPeakImportError, setOffPeakImportError] = useState()
  const [offPeakExportError, setOffPeakExportError] = useState()
  const [peakImportError, setPeakImportError] = useState()
  const [peakExportError, setPeakExportError] = useState()
  const [offPeakImportThumbnail, setOffPeakImportThumbnail] = useState()
  const [offPeakExportThumbnail, setOffPeakExportThumbnail] = useState()
  const [peakImportThumbnail, setPeakImportThumbnail] = useState()
  const [peakExportThumbnail, setPeakExportThumbnail] = useState()
  const [billMonthForImages, setBillMonthForImages] = useState();
  const [billHistInfo, setBillHistInfo] = useState([]);

  const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] = useState("");
  const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] = useState("");
  const [lastPaidBill, setLastPaidBill] = useState('');

  const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail,] = useState("");
  const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail,] = useState("");
  const [lastPaidBillThumbnail, setLastPaidBillThumbnail] = useState('');
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('')
  const [applicantCnicBackError, setApplicantCnicBackError] = useState('')
  const [lastBillError, setLastBillError] = useState('');

  const [ccCode, setccCode] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [lpsAmount, setLpsAmount] = useState();
  const [dueDate, setDueDate] = useState();
  const [consumerFatherName, setConsumerFatherName] = useState();
  const [multiplyingFactor, setMultiplyingFactor] = useState();
  const [feederCode, setFeederCode] = useState();
  const [meterCode, setMeterCode] = useState();
  const [meterRange, setMeterRange] = useState();
  const [mdiReset, setMdiReset] = useState();
  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  //#endregion

  //#region Functions
  const ApplicantCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setApplicantCnicDocumentFront, setApplicantCnicFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
    }
  };

  const ApplicantCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setApplicantCnicDocumentBack, setApplicantCnicBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
    }
  };

  const LastPaidBill = (event) => {
    if (event.target.files) {
      const newFileName = 'LastBillDocument.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setLastPaidBill, setLastBillError, setLastPaidBillThumbnail, newFileName);
    }
  }

  const handleChangeImagesDoNotMatch = (event) => {
    setIsCheckedImagesDoNotMatch(event.target.checked);
  };

  const handleChangeImagesAreBlur = (event) => {
    setIsCheckedImagesAreBlur(event.target.checked);
  };

  const handleChangeOthers = (event) => {
    setIsCheckedOthers(event.target.checked);
  };

  function isTariffPresent(consumer_tariff) {
    return mdiTrifs.some(item => item.tariffDesc.replace(/\s/g, '').toLowerCase() === consumer_tariff.replace(/\s/g, '').toLowerCase());
  }

  const errorCloses = () => {
    setError('')
  }

  const handleClose = () => {
    setMeterReadingPopUp(false);
    window.location.href = 'meter-reading-correction-table';
  };

  const printApplicationReceipt = (values, applicationID, userName, referenceNo) => {
    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(mepcologo, "PNG", 90, height, 30, 10); // Adjust the position and size of the barcode image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Meter Reading Correction Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");



    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userName, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };


  const SearchBy = (e) => {

    // Reset related fields and state
    setDefaultCircle();
    setConnectionType('')
    setError('');
    setDefaultDivision();
    setSubDivision();
    setReferenceNumber();
    setCustomerId()
    setAddress('');
    setTariff('');
    setBillMonthForImages('')
    mrcFormik.resetForm();
    mrcFormik.setFieldValue('iv_search_by', e.target.value); // Correct way to update the form value
    mrcFormik.setFieldValue('iv_phase', ''); // Correct way to update the form value
    setccCode();
    setTotalAmount();
    setLpsAmount();
    setDueDate();
    setConsumerFatherName();
    setMultiplyingFactor();
    setFeederCode();
    setMeterCode();
    setMeterRange();
    setMdiReset();
    // Reset other stateful elements
    setMeterImage1();
    setMeterImage2();
    setMeterImage3();
    setMeterImage4();
    setOffPeakImport();
    setOffPeakExport();
    setPeakImport();
    setPeakExport();
    setOffPeakImportError();
    setOffPeakExportError();
    setPeakImportError();
    setPeakExportError();
    setOffPeakImportThumbnail();
    setOffPeakExportThumbnail();
    setPeakImportThumbnail();
    setPeakExportThumbnail();
    setApplicantCnicDocumentFront()
    setApplicantCnicDocumentBack()
    setApplicantCnicFrontError()
    setApplicantCnicBackError()
    setApplicantCnicDocumentFrontThumbnail()
    setApplicantCnicDocumentBackThumbnail()
    setLastPaidBill()
    setLastBillError()
    setLastPaidBillThumbnail()
    setIsCheckedImagesDoNotMatch(false);
  }

  const referenceApi = async () => {
    if (mrcFormik.values.iv_search_by === 'consumerId') {
      setViewBackdrop(true)
      if (!mrcFormik.values.iv_consumer_id) return;
      let apiResponse = await dBillAPI(token, mrcFormik.values.iv_consumer_id)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        const cummReadingInfo = apiResponse.cummReadingInfo ? apiResponse.cummReadingInfo : []
        const meterInfo = apiResponse.metersInfo
        let refNo = basicInfo.refNo.replace(/ /g, "").slice(0, 14)
        let response = await disconnectionDetails(token, refNo)

        setccCode(basicInfo.cc_code);
        setTotalAmount(basicInfo.netBill);
        setLpsAmount(basicInfo.LatePaymentSurcharge);
        setDueDate(basicInfo.billDueDate);
        setConsumerFatherName(basicInfo.consumerFName);
        setMultiplyingFactor(meterInfo[0].mtrKwhMF);
        setFeederCode(basicInfo.feederCode);
        setMeterCode(response.rows[0].KWH_METER_CODE);
        setMeterRange(response.rows[0].KWH_METER_RANGE);
        setMdiReset(cummReadingInfo.length > 0 ? cummReadingInfo[0].resetNo : 1);

        mrcFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mrcFormik.values.iv_address = basicInfo.consumerAddress1 + ' ' + basicInfo.consumerAddress2
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        mrcFormik.values.iv_meter_type = basicInfo.meterType ? basicInfo.meterType : 'Normal'
        mrcFormik.values.iv_meter_phase = basicInfo.phase ? basicInfo.phase : meterInfo.length === 1 ? 'S-PHASE' : '3-PHASE'
        mrcFormik.values.iv_phase = getPhase(basicInfo.sactionLoad)
        mrcFormik.values.iv_meter_no = getRightSideNumbers(meterInfo[0].mtrNo)

        let month = basicInfo.billMonth

        mrcFormik.values.iv_applicant_name = basicInfo.consumerName
        mrcFormik.values.iv_father_name = basicInfo.consumerFName
        mrcFormik.values.iv_applicant_cnic = basicInfo.owner_cnic
        mrcFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mrcFormik.values.iv_applicant_email = basicInfo.consumerEmail

        setTariff(basicInfo.tariffDescription)

        mrcFormik.values.iv_connection_type = basicInfo.cons_cat
        mrcFormik.values.iv_tariff_description = basicInfo.tariffDescription
        mrcFormik.values.iv_tariff_code = basicInfo.tariffCode

        const batchNumber = refNo.slice(0, 2);
        const divisionCode = refNo.slice(2, 6);
        const year = month.split('-')[0];
        const months = month.split('-')[1];
        const formattedDate = year + months;
        const circleCode = refNo.slice(2, 5);
        const companyCode = refNo.slice(2, 4);
        mrcFormik.values.iv_billing_month = formattedDate
        setBillMonthForImages(formattedDate)


        const noOfObjectsInMetersInfo = meterInfo.length
        let meterType = ''
        if (noOfObjectsInMetersInfo === 1) {
          setConnectionType('1 phase meter')
          meterType = '1 phase meter'
        } else if (noOfObjectsInMetersInfo === 2) {
          let isMDITariff = isTariffPresent(basicInfo.tariffDescription)
          if (!isMDITariff) {
            setConnectionType('3 phase meter')
            meterType = '3 phase meter'
          } else {
            setConnectionType('3 phase mdi meter')
            meterType = '3 phase mdi meter'
          }
        } else if (noOfObjectsInMetersInfo === 4) {
          if (cummReadingInfo.length > 0) {
            setConnectionType('3 phase mdi net meter')
            meterType = '3 phase mdi net meter'
          } else {
            setConnectionType('net meter')
            meterType = 'net meter'
          }
        }

        if (meterType == '1 phase meter') {
          mrcFormik.values.iv_previous_reading_single_phase = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_current_reading_single_phase = meterInfo[0].mtrKwhPrsRead
        } else if (meterType == '3 phase meter') {
          mrcFormik.values.iv_previous_off_peak_three_phase = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_three_phase = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_current_off_peak_three_phase = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_three_phase = meterInfo[1].mtrKwhPrsRead
        } else if (meterType == '3 phase mdi meter') {
          mrcFormik.values.iv_previous_kwh_off_peak_three_phase_mdi = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kwh_peak_three_phase_mdi = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi = meterInfo[0].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi = meterInfo[1].mtrKvhPrvRead
          mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prvCummMdi
          mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi = cummReadingInfo[1].prvCummMdi
          mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_kwh_peak_three_phase_mdi = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi = meterInfo[0].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi = meterInfo[1].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prsCummMdi
          mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prsCummMdi
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi = cummReadingInfo[1].prsCummMdi
          mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi = cummReadingInfo[1].prsCummMdi
        } else if (meterType == 'net meter') {
          mrcFormik.values.iv_previous_offpeak_import = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_import = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_offpeak_export = meterInfo[2].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_export = meterInfo[3].mtrKwhPrvRead
          mrcFormik.values.iv_current_offpeak_import = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_import = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_offpeak_export = meterInfo[2].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_export = meterInfo[3].mtrKwhPrsRead
        } else if (meterType == '3 phase mdi net meter') {
          mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_import = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_import = meterInfo[1].mtrKvhPrvRead
          // mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_import = meterInfo[0].mtrMdiPrvRead
          // mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_import = meterInfo[1].mtrMdiPrvRead
          mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_export = meterInfo[3].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_export = meterInfo[3].mtrKvhPrvRead
          // mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_export = meterInfo[2].mtrMdiPrvRead
          // mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_export = meterInfo[3].mtrMdiPrvRead
          mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import = meterInfo[1].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_import = meterInfo[0].mtrMdiPrsRead
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_import = meterInfo[1].mtrMdiPrsRead
          mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKwhPrsRead
          mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export = meterInfo[3].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export = meterInfo[3].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_export = meterInfo[2].mtrMdiPrsRead
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_export = meterInfo[3].mtrMdiPrsRead
        }

        let HistInfoArray = apiResponse.histInfo
        let convertedArray = convertToObjectArray(HistInfoArray)
        setBillHistInfo(convertedArray)

        if (meterType == '1 phase meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
        } else if (meterType == '3 phase meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
        } else if (meterType == '3 phase mdi meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        } else if (meterType == '3 phase mdi net meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        } else if (meterType == 'net meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        }

      } else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID!')
      } else {
        setError('Customer ID. not found!')
      }
      setViewBackdrop(false)
    }
    else if (mrcFormik.values.iv_search_by === 'referenceNo') {
      setViewBackdrop(true)
      if (!mrcFormik.values.iv_reference_number) return;
      let apiResponse = await dBillAPI(token, mrcFormik.values.iv_reference_number)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        const cummReadingInfo = apiResponse.cummReadingInfo ? apiResponse.cummReadingInfo : []
        const meterInfo = apiResponse.metersInfo
        let refNo = basicInfo.refNo.replace(/ /g, "").slice(0, 14)
        let response = await disconnectionDetails(token, refNo)

        setccCode(basicInfo.cc_code);
        setTotalAmount(basicInfo.netBill);
        setLpsAmount(basicInfo.LatePaymentSurcharge);
        setDueDate(basicInfo.billDueDate);
        setConsumerFatherName(basicInfo.consumerFName);
        setMultiplyingFactor(meterInfo[0].mtrKwhMF);
        setFeederCode(basicInfo.feederCode);
        setMeterCode(response.rows[0].KWH_METER_CODE);
        setMeterRange(response.rows[0].KWH_METER_RANGE);
        setMdiReset(cummReadingInfo.length > 0 ? cummReadingInfo[0].resetNo : 1);

        mrcFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mrcFormik.values.iv_address = basicInfo.consumerAddress1 + ' ' + basicInfo.consumerAddress2
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        mrcFormik.values.iv_meter_type = basicInfo.meterType ? basicInfo.meterType : 'Normal'
        mrcFormik.values.iv_meter_phase = basicInfo.phase ? basicInfo.phase : meterInfo.length === 1 ? 'S-PHASE' : '3-PHASE'
        mrcFormik.values.iv_phase = getPhase(basicInfo.sactionLoad)
        mrcFormik.values.iv_meter_no = getRightSideNumbers(meterInfo[0].mtrNo)

        let month = basicInfo.billMonth

        mrcFormik.values.iv_applicant_name = basicInfo.consumerName
        mrcFormik.values.iv_father_name = basicInfo.consumerFName
        mrcFormik.values.iv_applicant_cnic = basicInfo.owner_cnic
        mrcFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mrcFormik.values.iv_applicant_email = basicInfo.consumerEmail

        setTariff(basicInfo.tariffDescription)

        mrcFormik.values.iv_connection_type = basicInfo.cons_cat
        mrcFormik.values.iv_tariff_description = basicInfo.tariffDescription
        mrcFormik.values.iv_tariff_code = basicInfo.tariffCode

        const batchNumber = refNo.slice(0, 2);
        const divisionCode = refNo.slice(2, 6);
        const year = month.split('-')[0];
        const months = month.split('-')[1];
        const formattedDate = year + months;
        const circleCode = refNo.slice(2, 5);
        const companyCode = refNo.slice(2, 4);
        mrcFormik.values.iv_billing_month = formattedDate
        setBillMonthForImages(formattedDate)


        const noOfObjectsInMetersInfo = meterInfo.length
        let meterType = ''
        if (noOfObjectsInMetersInfo === 1) {
          setConnectionType('1 phase meter')
          meterType = '1 phase meter'
        } else if (noOfObjectsInMetersInfo === 2) {
          let isMDITariff = isTariffPresent(basicInfo.tariffDescription)
          if (!isMDITariff) {
            setConnectionType('3 phase meter')
            meterType = '3 phase meter'
          } else {
            setConnectionType('3 phase mdi meter')
            meterType = '3 phase mdi meter'
          }
        } else if (noOfObjectsInMetersInfo === 4) {
          if (cummReadingInfo.length > 0) {
            setConnectionType('3 phase mdi net meter')
            meterType = '3 phase mdi net meter'
          } else {
            setConnectionType('net meter')
            meterType = 'net meter'
          }
        }

        if (meterType == '1 phase meter') {
          mrcFormik.values.iv_previous_reading_single_phase = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_current_reading_single_phase = meterInfo[0].mtrKwhPrsRead
        } else if (meterType == '3 phase meter') {
          mrcFormik.values.iv_previous_off_peak_three_phase = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_three_phase = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_current_off_peak_three_phase = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_three_phase = meterInfo[1].mtrKwhPrsRead
        } else if (meterType == '3 phase mdi meter') {
          mrcFormik.values.iv_previous_kwh_off_peak_three_phase_mdi = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kwh_peak_three_phase_mdi = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi = meterInfo[0].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi = meterInfo[1].mtrKvhPrvRead
          mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prvCummMdi
          mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi = cummReadingInfo[1].prvCummMdi
          mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_kwh_peak_three_phase_mdi = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi = meterInfo[0].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi = meterInfo[1].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prsCummMdi
          mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi = cummReadingInfo[0].prsCummMdi
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi = cummReadingInfo[1].prsCummMdi
          mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi = cummReadingInfo[1].prsCummMdi
        } else if (meterType == 'net meter') {
          mrcFormik.values.iv_previous_offpeak_import = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_import = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_offpeak_export = meterInfo[2].mtrKwhPrvRead
          mrcFormik.values.iv_previous_peak_export = meterInfo[3].mtrKwhPrvRead
          mrcFormik.values.iv_current_offpeak_import = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_import = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_offpeak_export = meterInfo[2].mtrKwhPrsRead
          mrcFormik.values.iv_current_peak_export = meterInfo[3].mtrKwhPrsRead
        } else if (meterType == '3 phase mdi net meter') {
          mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_import = meterInfo[1].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_import = meterInfo[1].mtrKvhPrvRead
          // mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_import = meterInfo[0].mtrMdiPrvRead
          // mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_import = meterInfo[1].mtrMdiPrvRead
          mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_export = meterInfo[3].mtrKwhPrvRead
          mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKvhPrvRead
          mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_export = meterInfo[3].mtrKvhPrvRead
          // mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_export = meterInfo[2].mtrMdiPrvRead
          // mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_export = meterInfo[3].mtrMdiPrvRead
          mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKwhPrsRead
          mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import = meterInfo[1].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import = meterInfo[0].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import = meterInfo[1].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_import = meterInfo[0].mtrMdiPrsRead
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_import = meterInfo[1].mtrMdiPrsRead
          mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKwhPrsRead
          mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export = meterInfo[3].mtrKwhPrsRead
          mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export = meterInfo[2].mtrKvhPrsRead
          mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export = meterInfo[3].mtrKvhPrsRead
          mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_export = meterInfo[2].mtrMdiPrsRead
          mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_export = meterInfo[3].mtrMdiPrsRead
        }

        let HistInfoArray = apiResponse.histInfo
        let convertedArray = convertToObjectArray(HistInfoArray)
        setBillHistInfo(convertedArray)

        if (meterType == '1 phase meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
        } else if (meterType == '3 phase meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
        } else if (meterType == '3 phase mdi meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        } else if (meterType == '3 phase mdi net meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        } else if (meterType == 'net meter') {
          setMeterImage1('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '1E.jpg',);
          setMeterImage2('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '2E.jpg',);
          setMeterImage3('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '3E.jpg',);
          setMeterImage4('https://snaps.pitc.com.pk/' + companyCode + '000/' + circleCode + '00/' + divisionCode + '0' + '/' + formattedDate + '-' + batchNumber + '/' + formattedDate + refNo + '4E.jpg',);
        }
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Reference No!')
      } else {
        setError('Reference No. not found!')
      }
    }
    setViewBackdrop(false)
  };

  const OffPeakImport = (event) => {

    if (event.type === 'click') {
      fileInputRefOffPeakImport.current.click(); // Simulate click on the hidden input
    }

    if (event.target.files) {
      const newFileName = 'offPeakImport.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setOffPeakImport, setOffPeakImportError, setOffPeakImportThumbnail, newFileName);
    }
  };

  const PeakImport = (event) => {
    if (event.type === 'click') {
      fileInputRefPeakImport.current.click(); // Simulate click on the hidden input
    }

    if (event.target.files) {
      const newFileName = 'peakImport.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setPeakImport, setPeakImportError, setPeakImportThumbnail, newFileName);
    }
  }

  const OffPeakExport = (event) => {
    if (event.type === 'click') {
      fileInputRefOffPeakExport.current.click(); // Simulate click on the hidden input
    }

    if (event.target.files) {
      const newFileName = 'offPeakExport.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setOffPeakExport, setOffPeakExportError, setOffPeakExportThumbnail, newFileName);
    }
  }

  const PeakExport = (event) => {
    if (event.type === 'click') {
      fileInputRefPeakExport.current.click(); // Simulate click on the hidden input
    }

    if (event.target.files) {
      const newFileName = 'PeakImport.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mrcFormik.handleChange, setPeakExport, setPeakExportError, setPeakExportThumbnail, newFileName);
    }
  }

  const getPreviousMonthImages = () => {
    const batchNumber = referenceNumber.slice(0, 2);
    const divisionCode = referenceNumber.slice(2, 6);
    const month = getPreviousMonth(billMonthForImages);
    const formattedDate = month;
    setBillMonthForImages(month);
    const circleCode = referenceNumber.slice(2, 5);
    const companyCode = referenceNumber.slice(2, 4);
    setMeterImage1(
      'https://snaps.pitc.com.pk/' +
      companyCode +
      '000/' +
      circleCode +
      '00/' +
      divisionCode +
      '0' +
      '/' +
      formattedDate +
      '-' +
      batchNumber +
      '/' +
      formattedDate +
      referenceNumber +
      '1E.jpg',
    );
    if (meterImage2) {
      setMeterImage2(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '2E.jpg',
      );
    }
    if (meterImage3 && meterImage4) {
      setMeterImage3(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '3E.jpg',
      );
      setMeterImage4(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '4E.jpg',
      );
    }
  }

  const getNextMonthImages = () => {
    const batchNumber = referenceNumber.slice(0, 2);
    const divisionCode = referenceNumber.slice(2, 6);
    const month = getNextMonth(billMonthForImages);
    const formattedDate = month;
    setBillMonthForImages(month)
    const circleCode = referenceNumber.slice(2, 5);
    const companyCode = referenceNumber.slice(2, 4);
    setMeterImage1(
      'https://snaps.pitc.com.pk/' +
      companyCode +
      '000/' +
      circleCode +
      '00/' +
      divisionCode +
      '0' +
      '/' +
      formattedDate +
      '-' +
      batchNumber +
      '/' +
      formattedDate +
      referenceNumber +
      '1E.jpg',
    );
    if (meterImage2) {
      setMeterImage2(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '2E.jpg',
      );
    }
    if (meterImage3 && meterImage4) {
      setMeterImage3(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '3E.jpg',
      );
      setMeterImage4(
        'https://snaps.pitc.com.pk/' +
        companyCode +
        '000/' +
        circleCode +
        '00/' +
        divisionCode +
        '0' +
        '/' +
        formattedDate +
        '-' +
        batchNumber +
        '/' +
        formattedDate +
        referenceNumber +
        '4E.jpg',
      );
    }
  }

  //#endregion

  //#region Formik
  const mrcFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_search_by: Yup.mixed().required('Select search by.'),
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => mrcFormik.values.iv_search_by === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number.").matches(/^[0-9]+$/, "Enter 14 digit reference number as 01234567891234"),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => mrcFormik.values.iv_search_by === 'consumerId',
        then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_address: Yup.string().optional(),
      // Meter Details Validations
      iv_meter_phase: Yup.string().required('Meter phase is unavailable.'),
      iv_meter_no: Yup.string().required('Meter no. is unavailable.'),
      iv_meter_type: Yup.string().required('Meter type is unavailable.'),
      // Reading Details Fields
      iv_billing_month: Yup.string().required('Billing month unavailable.'),

      //#region single phase
      iv_previous_reading_single_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '1 phase meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_reading_single_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '1 phase meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_reading_single_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '1 phase meter',
        then: Yup.number().required('Enter Claimed Reading.').min(Yup.ref('iv_previous_reading_single_phase'), `Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      //#endregion

      //#region three phase
      iv_previous_off_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_off_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_off_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Enter Offpeak Claimed Reading.').min(Yup.ref('iv_previous_off_peak_three_phase'), `Offpeak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_peak_three_phase: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase meter',
        then: Yup.number().required('Enter Peak Claimed Reading.').min(Yup.ref('iv_previous_peak_three_phase'), `Peak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      //#endregion

      //#region net meter
      iv_previous_offpeak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Previous Off Peak Import Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_peak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Previous Peak Import Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_offpeak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Previous Off Peak Export Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_peak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Previous Peak Export Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_offpeak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Current Off Peak Import Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_peak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Current Peak Import Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_offpeak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Current Off Peak Export Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_peak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Current Peak Export Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_offpeak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Enter Off Peak Import Claimed Reading.').min(Yup.ref('iv_previous_offpeak_import'), `Off Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_peak_import: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Enter Peak Import Claimed Reading.').min(Yup.ref('iv_previous_peak_import'), `Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_offpeak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Enter Off Peak Export Claimed Reading.').min(Yup.ref('iv_previous_offpeak_export'), `Off Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_peak_export: Yup.number().when('connectionType', {
        is: () => connectionType == 'net meter',
        then: Yup.number().required('Enter Peak Export Claimed Reading.').min(Yup.ref('iv_previous_peak_export'), `Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      //#endregion

      //#region three phase mdi meter
      iv_previous_kwh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kwh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_mdi_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_mdi_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kwh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kwh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kwh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Off Peak Claimed Reading.').min(Yup.ref('iv_previous_kwh_off_peak_three_phase_mdi'), `Off Peak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kwh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Peak Claimed Reading.').min(Yup.ref('iv_previous_kwh_peak_three_phase_mdi'), `Peak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Off Peak Claimed Reading.').min(Yup.ref('iv_previous_kVArh_off_peak_three_phase_mdi'), `Off Peak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Peak Claimed Reading.').min(Yup.ref('iv_previous_kVArh_peak_three_phase_mdi'), `Peak Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_mdi_off_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Off Peak MDI Claimed Reading.').min(0, `Off Peak MDI Claimed reading can't be less than 0!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_mdi_peak_three_phase_mdi: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi meter',
        then: Yup.number().required('Enter Peak MDI Claimed Reading.').min(0, `Peak Claimed reading can't be less than 0!`),
        otherwise: Yup.number().optional()
      }),
      //#endregion

      //#region 3 phase mdi net meter
      iv_previous_kWh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kWh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      // iv_previous_mdi_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
      //   is: () => connectionType == '3 phase mdi net meter',
      //   then: Yup.number().required('Previous Reading is unavailable.'),
      //   otherwise: Yup.number().optional()
      // }),
      // iv_previous_mdi_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
      //   is: () => connectionType == '3 phase mdi net meter',
      //   then: Yup.number().required('Previous Reading is unavailable.'),
      //   otherwise: Yup.number().optional()
      // }),
      iv_previous_kWh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kWh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_previous_kVArh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Previous Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      // iv_previous_mdi_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
      //   is: () => connectionType == '3 phase mdi net meter',
      //   then: Yup.number().required('Previous Reading is unavailable.'),
      //   otherwise: Yup.number().optional()
      // }),
      // iv_previous_mdi_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
      //   is: () => connectionType == '3 phase mdi net meter',
      //   then: Yup.number().required('Previous Reading is unavailable.'),
      //   otherwise: Yup.number().optional()
      // }),
      iv_current_kWh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kWh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kWh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kWh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_kVArh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_current_mdi_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Current Reading is unavailable.'),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kWh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Off Peak Import Claimed Reading.').min(Yup.ref('iv_previous_kWh_off_peak_three_phase_mdi_import'), `Off Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kWh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Peak Import Claimed Reading.').min(Yup.ref('iv_previous_kWh_peak_three_phase_mdi_import'), `Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_off_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Off Peak Import Claimed Reading.').min(Yup.ref('iv_previous_kVArh_off_peak_three_phase_mdi_import'), `Off Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_peak_three_phase_mdi_import: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Peak Import Claimed Reading.').min(Yup.ref('iv_previous_kVArh_peak_three_phase_mdi_import'), `Peak Import Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kWh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Off Peak Export Claimed Reading.').min(Yup.ref('iv_previous_kWh_off_peak_three_phase_mdi_export'), `Off Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kWh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Peak Export Claimed Reading.').min(Yup.ref('iv_previous_kWh_peak_three_phase_mdi_export'), `Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_off_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Off Peak Export Claimed Reading.').min(Yup.ref('iv_previous_kVArh_off_peak_three_phase_mdi_export'), `Off Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      iv_claimed_kVArh_peak_three_phase_mdi_export: Yup.number().when('connectionType', {
        is: () => connectionType == '3 phase mdi net meter',
        then: Yup.number().required('Enter Peak Export Claimed Reading.').min(Yup.ref('iv_previous_kVArh_peak_three_phase_mdi_export'), `Peak Export Claimed reading can't be less than last month!`),
        otherwise: Yup.number().optional()
      }),
      //#endregion

      //New Images fields
      iv_off_peak_import: Yup.string().required('Upload Claimed Reading image.'),
      iv_peak_import: Yup.string().when('connectionType', {
        is: () => connectionType != '1 phase meter',
        then: Yup.string().required('Upload Claimed Reading image.'),
        otherwise: Yup.string().optional()
      }),
      iv_off_peak_export: Yup.string().when('connectionType', {
        is: () => (connectionType != '1 phase meter' && connectionType != '3 phase meter'),
        then: Yup.string().required('Upload Claimed Reading image.'),
        otherwise: Yup.string().optional()
      }),
      iv_peak_export: Yup.string().when('connectionType', {
        is: () => (connectionType != '1 phase meter' && connectionType != '3 phase meter'),
        then: Yup.string().required('Upload Claimed Reading image.'),
        otherwise: Yup.string().optional()
      }),

      iv_connection_type: Yup.string('Category should be string.').optional(),
      // Applicant Details group Validations
      // iv_applicant_name: Yup.string().min(3, "Name should be atleast 3 characters.").max(30, "Name should be less than 30 characters.").required("Please enter applicant name."),
      // iv_applicant_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.").max(13, "Please enter 13 digit CNIC.").required("Please enter valid CNIC number.").matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
      iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").required("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      // iv_applicant_email: Yup.string().email("Enter email as 'john@gmail.com'.").notRequired(),
      iv_other_remarks: Yup.string().when('isCheckedOthers', {
        is: () => isCheckedOthers == true,
        then: Yup.string().required('Enter other remarks').max(100, `Remarks can't be more than 100 characters`),
        otherwise: Yup.string().optional()
      })
    }),
    onSubmit: async (values, { resetForm }) => {
      let callAPI = false;

      if (connectionType == '1 phase meter') {
        if (offPeakImportThumbnail) {
          callAPI = true
        } else {
          setOffPeakImportError('Upload Claimed Reading Image.')
        }
      } else if (connectionType == '3 phase meter') {
        if (!offPeakImportThumbnail) {
          setOffPeakImportError('Upload Claimed Reading Image.')
        }
        if (!peakImportThumbnail) {
          setPeakImportError('Upload Claimed Reading Image.')
        }
        if (offPeakImportThumbnail && peakImportThumbnail) {
          callAPI = true
        }
      } else if (connectionType == '3 phase mdi meter' || connectionType == 'net meter' || connectionType == "3 phase mdi net meter") {
        if (!offPeakImportThumbnail) {
          setOffPeakImportError('Upload Claimed Reading Image.')
        }
        if (!peakImportThumbnail) {
          setPeakImportError('Upload Claimed Reading Image.')
        }
        if (!offPeakExportThumbnail) {
          setOffPeakExportError('Upload Claimed Reading Image.')
        }
        if (!peakExportThumbnail) {
          setPeakExportError('Upload Claimed Reading Image.')
        }
        if (offPeakImportThumbnail && peakImportThumbnail && offPeakExportThumbnail && peakExportThumbnail) {
          callAPI = true
        }
      }

      if (callAPI) {
        setViewBackdrop(true);
        try {

          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", token);

          const raw = JSON.stringify({
            referenceNo: referenceNumber,
            customerId: customerId,
            ccCode: ccCode, //New
            totalAmount: totalAmount,//New
            lpsAmount: lpsAmount ? lpsAmount : 0,//New
            dueDate: new Date(dueDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).replace(/ /g, '-'),//New
            consumerFatherName: consumerFatherName,//New
            multiplyingFactor: multiplyingFactor, //New
            feederCode: feederCode,//New
            meterCode: meterCode,//New
            meterRange: meterRange,//New
            mdiReset: mdiReset,//New
            address: values.iv_address,
            meterPhase: values.iv_meter_phase,
            meterNo: values.iv_meter_no,
            meterPhaseType: connectionType,
            meterType: values.iv_meter_type,
            billingMonth: values.iv_billing_month,
            connectionType: values.iv_connection_type,
            applicantPhoneNo: values.iv_applicant_phone_no,
            tariff: values.iv_tariff_code,
            applicantCnicFrontImage: applicantCnicDocumentFrontThumbnail,
            applicantCnicBackImage: applicantCnicDocumentBackThumbnail,
            copyOfBill: lastPaidBillThumbnail,
            createdBy: userId,
            submittedThrough: portalName,
            remarks: 'Application Submitted',
            applicantCnic: values.iv_applicant_cnic,
            applicantName: values.iv_applicant_name,
            reason: ''.concat(isCheckedImagesDoNotMatch ? 'Image does not match with current reading. ' : '', isCheckedImagesAreBlur ? 'Image is blurred. ' : '', isCheckedOthers ? values.iv_other_remarks : ''),

            // Single Phase
            previousReadingSinglePhase: connectionType == "1 phase meter" ? values.iv_previous_reading_single_phase : "",
            currentReadingSinglePhase: connectionType == "1 phase meter" ? values.iv_current_reading_single_phase : "",
            claimedReadingSinglePhase: connectionType == "1 phase meter" ? values.iv_claimed_reading_single_phase : "",
            claimedReadingSinglePhaseImage: connectionType == "1 phase meter" ? offPeakImportThumbnail : "",

            // Three Phase
            previousOffPeakThreePhase: connectionType == "3 phase meter" ? values.iv_previous_off_peak_three_phase : "",
            previousPeakThreePhase: connectionType == "3 phase meter" ? values.iv_previous_peak_three_phase : "",
            currentOffPeakThreePhase: connectionType == "3 phase meter" ? values.iv_current_off_peak_three_phase : "",
            currentPeakThreePhase: connectionType == "3 phase meter" ? values.iv_current_peak_three_phase : "",
            claimedOffPeakThreePhase: connectionType == "3 phase meter" ? values.iv_claimed_off_peak_three_phase : "",
            claimedPeakThreePhase: connectionType == "3 phase meter" ? values.iv_claimed_peak_three_phase : "",
            claimedOffPeakThreePhaseImage: connectionType == "3 phase meter" ? offPeakImportThumbnail : "",
            claimedPeakThreePhaseImage: connectionType == "3 phase meter" ? peakImportThumbnail : "",

            // Net meter
            previousOffPeakImport: connectionType == "net meter" ? values.iv_previous_offpeak_import : "",
            previousPeakImport: connectionType == "net meter" ? values.iv_previous_peak_import : "",
            previousOffPeakExport: connectionType == "net meter" ? values.iv_previous_offpeak_export : "",
            previousPeakExport: connectionType == "net meter" ? values.iv_previous_peak_export : "",
            currentOffPeakImport: connectionType == "net meter" ? values.iv_current_offpeak_import : "",
            currentPeakImport: connectionType == "net meter" ? values.iv_current_peak_import : "",
            currentOffPeakExport: connectionType == "net meter" ? values.iv_current_offpeak_export : "",
            currentPeakExport: connectionType == "net meter" ? values.iv_current_peak_export : "",
            claimedOffPeakImport: connectionType == "net meter" ? values.iv_claimed_offpeak_import : "",
            claimedPeakImport: connectionType == "net meter" ? values.iv_claimed_peak_import : "",
            claimedOffPeakExport: connectionType == "net meter" ? values.iv_claimed_offpeak_export : "",
            claimedPeakExport: connectionType == "net meter" ? values.iv_claimed_peak_export : "",
            claimedOffPeakImportImage: connectionType == "net meter" ? offPeakImportThumbnail : "",
            claimedPeakImportImage: connectionType == "net meter" ? peakImportThumbnail : "",
            claimedOffPeakExportImage: connectionType == "net meter" ? offPeakExportThumbnail : "",
            claimedPeakExportImage: connectionType == "net meter" ? peakExportThumbnail : "",


            // Three Phase MDI
            previousOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_kwh_off_peak_three_phase_mdi : "",
            previousPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_kwh_peak_three_phase_mdi : "",
            previousMdiOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_mdi_off_peak_three_phase_mdi : "",
            previousMdiPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_mdi_peak_three_phase_mdi : "",
            currentOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_kwh_off_peak_three_phase_mdi : "",
            currentPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_kwh_peak_three_phase_mdi : "",
            currentMdiOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_mdi_off_peak_three_phase_mdi : "",
            currentMdiPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_mdi_peak_three_phase_mdi : "",
            claimedOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_kwh_off_peak_three_phase_mdi : "",
            claimedPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_kwh_peak_three_phase_mdi : "",
            claimedMdiOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_mdi_off_peak_three_phase_mdi : "",
            claimedMdiPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_mdi_peak_three_phase_mdi : "",
            previousKVARHOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_kVArh_off_peak_three_phase_mdi : "",
            previousKVARHPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_previous_kVArh_peak_three_phase_mdi : "",
            currentKVARHOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_kVArh_off_peak_three_phase_mdi : "",
            currentKVARHPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_current_kVArh_peak_three_phase_mdi : "",
            claimedKVARHOffPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_kVArh_off_peak_three_phase_mdi : "",
            claimedKVARHPeakThreePhaseMdi: connectionType == "3 phase mdi meter" ? values.iv_claimed_kVArh_peak_three_phase_mdi : "",
            claimedOffPeakThreePhaseMdiImage: connectionType == "3 phase mdi meter" ? offPeakImportThumbnail : "",
            claimedPeakThreePhaseMdiImage: connectionType == "3 phase mdi meter" ? peakImportThumbnail : "",
            claimedKVARHOffPeakThreePhaseMdiImage: connectionType == "3 phase mdi meter" ? offPeakExportThumbnail : "",
            claimedKVARHPeakThreePhaseMdiImage: connectionType == "3 phase mdi meter" ? peakExportThumbnail : "",

            // Three Phase MDI Net Meter
            //Import
            previousOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_off_peak_three_phase_mdi_import : "",
            previousPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_peak_three_phase_mdi_import : "",
            previouskVArhOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kVArh_off_peak_three_phase_mdi_import : "",
            previouskVArhPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kVArh_peak_three_phase_mdi_import : "",
            previousMdiOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_mdi_off_peak_three_phase_mdi_import : "",
            previousMdiPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_mdi_peak_three_phase_mdi_import : "",
            currentOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_kWh_off_peak_three_phase_mdi_import : "",
            currentPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_kWh_peak_three_phase_mdi_import : "",
            currentkVArhOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_kVArh_off_peak_three_phase_mdi_import : "",
            currentkVArhPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_kVArh_peak_three_phase_mdi_import : "",
            currentMdiOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_mdi_off_peak_three_phase_mdi_import : "",
            currentMdiPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_current_mdi_peak_three_phase_mdi_import : "",
            claimedOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kWh_off_peak_three_phase_mdi_import : "",
            claimedPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kWh_peak_three_phase_mdi_import : "",
            claimedkVArhOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kVArh_off_peak_three_phase_mdi_import : "",
            claimedkVArhPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kVArh_peak_three_phase_mdi_import : "",
            claimedMdiOffPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_mdi_off_peak_three_phase_mdi_import : "",
            claimedMdiPeakThreePhaseMdiImport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_mdi_peak_three_phase_mdi_import : "",
            claimedOffPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? offPeakImportThumbnail : "",
            claimedPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? peakImportThumbnail : "",
            // claimedkVArhOffPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? offPeakExportThumbnail : "",
            // claimedkVArhPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
            // claimedMdiOffPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_off_peak_three_phase_mdi_import : "",
            // claimedMdiPeakThreePhaseMdiImageImport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_off_peak_three_phase_mdi_import : "",
            //Export
            previousOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_off_peak_three_phase_mdi_export : "",
            previousPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kWh_peak_three_phase_mdi_export : "",
            previouskVArhOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kVArh_off_peak_three_phase_mdi_export : "",
            previouskVArhPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_kVArh_peak_three_phase_mdi_export : "",
            previousMdiOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_mdi_off_peak_three_phase_mdi_export : "",
            previousMdiPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_previous_mdi_peak_three_phase_mdi_export : "",
            currentOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_kWh_off_peak_three_phase_mdi_export : "",
            currentPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_kWh_peak_three_phase_mdi_export : "",
            currentkVArhOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_kVArh_off_peak_three_phase_mdi_export : "",
            currentkVArhPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_kVArh_peak_three_phase_mdi_export : "",
            currentMdiOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_mdi_off_peak_three_phase_mdi_export : "",
            currentMdiPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_current_mdi_peak_three_phase_mdi_export : "",
            claimedOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kWh_off_peak_three_phase_mdi_export : "",
            claimedPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kWh_peak_three_phase_mdi_export : "",
            claimedkVArhOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kVArh_off_peak_three_phase_mdi_export : "",
            claimedkVArhPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_kVArh_peak_three_phase_mdi_export : "",
            claimedMdiOffPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_mdi_off_peak_three_phase_mdi_export : "",
            claimedMdiPeakThreePhaseMdiExport: connectionType == "3 phase mdi net meter" ? values.iv_claimed_mdi_peak_three_phase_mdi_export : "",
            claimedOffPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? offPeakExportThumbnail : "",
            claimedPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
            // claimedkVArhOffPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
            // claimedkVArhPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
            // claimedMdiOffPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
            // claimedMdiPeakThreePhaseMdiImageExport: connectionType == "3 phase mdi net meter" ? peakExportThumbnail : "",
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
          };

          await fetch(cfpBaseUrl + "mrc/registerMRCApplication", requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result.status === "200") {
                let complaintId = result.eOpsTrackingId
                resetForm()
                setTariff()
                setReferenceNumber()
                setccCode();
                setTotalAmount();
                setLpsAmount();
                setDueDate();
                setConsumerFatherName();
                setMultiplyingFactor();
                setFeederCode();
                setMeterCode();
                setMeterRange();
                setMdiReset();
                setCustomerId()
                setMeterImage1()
                setMeterImage2()
                setMeterImage3()
                setMeterImage4()
                setDefaultCircle()
                setDefaultDivision()
                setSubDivision()
                setComplaintId(complaintId)
                setMeterReadingPopUp(true)
                printApplicationReceipt(values, complaintId, userName, referenceNumber);
              } else {
                if (typeof result.message == 'string') {
                  setError(result.message);
                } else if (Array.isArray(result.message) && result.message.length > 0) {
                  setError(result.message[0]);
                } else {
                  setError('An unknown error occurred');
                }
              }
            })
            .catch(error => setError(error));
        }
        catch (e) {
          setError('Failed to submit request! Please try later.')
        }
        setViewBackdrop(false)
      }
    }
  })
  //#endregion

  //#region useEffects
  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivList)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  useEffect(() => {
    if (mrcFormik.values.iv_consumer_id.length === 10) {
      referenceApi();
    } else {
      setDefaultCircle()
      setError('')
      setDefaultDivision()
      setSubDivision()
      setReferenceNumber()
      setCustomerId()
      setAddress('')
      setConnectionType('')
      mrcFormik.values.iv_phase = ''
      setTariff('')
      mrcFormik.values.iv_reference_number = ''
      mrcFormik.values.iv_circle = ''
      mrcFormik.values.iv_division = ''
      mrcFormik.values.iv_sub_divison = ''
      mrcFormik.values.iv_address = ''
      mrcFormik.values.iv_meter_phase = ''
      mrcFormik.values.iv_meter_no = ''
      mrcFormik.values.iv_meter_type = ''
      mrcFormik.values.iv_billing_month = ''
      mrcFormik.values.iv_connection_type = ''
      mrcFormik.values.iv_tariff_description = ''
      mrcFormik.values.iv_tariff_code = ''
      setBillMonthForImages('')

      setccCode();
      setTotalAmount();
      setLpsAmount();
      setDueDate();
      setConsumerFatherName();
      setMultiplyingFactor();
      setFeederCode();
      setMeterCode();
      setMeterRange();
      setMdiReset();


      //single phase readings
      mrcFormik.values.iv_previous_reading_single_phase = ''
      mrcFormik.values.iv_current_reading_single_phase = ''
      mrcFormik.values.iv_claimed_reading_single_phase = ''

      //3 phase readings
      mrcFormik.values.iv_previous_off_peak_three_phase = ''
      mrcFormik.values.iv_previous_peak_three_phase = ''
      mrcFormik.values.iv_current_off_peak_three_phase = ''
      mrcFormik.values.iv_current_peak_three_phase = ''
      mrcFormik.values.iv_claimed_off_peak_three_phase = ''
      mrcFormik.values.iv_claimed_peak_three_phase = ''

      //3 phase mdi readings
      mrcFormik.values.iv_previous_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi = ''

      //net meter
      mrcFormik.values.iv_previous_offpeak_import = ''
      mrcFormik.values.iv_previous_peak_import = ''
      mrcFormik.values.iv_previous_offpeak_export = ''
      mrcFormik.values.iv_previous_peak_export = ''
      mrcFormik.values.iv_current_offpeak_import = ''
      mrcFormik.values.iv_current_peak_import = ''
      mrcFormik.values.iv_current_offpeak_export = ''
      mrcFormik.values.iv_current_peak_export = ''
      mrcFormik.values.iv_claimed_offpeak_import = ''
      mrcFormik.values.iv_claimed_peak_import = ''
      mrcFormik.values.iv_claimed_offpeak_export = ''
      mrcFormik.values.iv_claimed_peak_export = ''

      // 3 phase mdi net meter
      mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi_import = '';
      mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi_export = '';
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi_export = '';

      mrcFormik.values.iv_applicant_name = ''
      mrcFormik.values.iv_father_name = ''
      mrcFormik.values.iv_applicant_cnic = ''
      mrcFormik.values.iv_applicant_phone_no = ''
      mrcFormik.values.iv_applicant_email = ''
      mrcFormik.values.iv_applicant_cnic_document_front = null
      mrcFormik.values.iv_applicant_cnic_document_back = null
      setMeterImage1()
      setMeterImage2()
      setMeterImage3()
      setMeterImage4()
      setOffPeakImport()
      setOffPeakExport()
      setPeakImport()
      setPeakExport()
      setOffPeakImportError()
      setOffPeakExportError()
      setPeakImportError()
      setPeakExportError()
      setOffPeakImportThumbnail()
      setOffPeakExportThumbnail()
      setPeakImportThumbnail()
      setPeakExportThumbnail()
      setApplicantCnicDocumentFront()
      setApplicantCnicDocumentBack()
      setApplicantCnicFrontError()
      setApplicantCnicBackError()
      setApplicantCnicDocumentFrontThumbnail()
      setApplicantCnicDocumentBackThumbnail()
      setLastPaidBill()
      setLastBillError()
      setLastPaidBillThumbnail()
      setIsCheckedImagesDoNotMatch(false)
    }
  }, [mrcFormik.values.iv_consumer_id])

  useEffect(() => {
    if (mrcFormik.values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle()
      setConnectionType('')
      setError('')
      setDefaultDivision()
      setSubDivision()
      setReferenceNumber()
      setCustomerId()
      setAddress('')
      setccCode();
      setTotalAmount();
      setLpsAmount();
      setDueDate();
      setConsumerFatherName();
      setMultiplyingFactor();
      setFeederCode();
      setMeterCode();
      setMeterRange();
      setMdiReset();
      setTariff('')
      mrcFormik.values.iv_phase = ''
      mrcFormik.values.iv_consumer_id = ''
      mrcFormik.values.iv_circle = ''
      mrcFormik.values.iv_division = ''
      mrcFormik.values.iv_sub_divison = ''
      mrcFormik.values.iv_address = ''
      mrcFormik.values.iv_meter_phase = ''
      mrcFormik.values.iv_meter_no = ''
      mrcFormik.values.iv_meter_type = ''
      mrcFormik.values.iv_billing_month = ''
      mrcFormik.values.iv_connection_type = ''
      mrcFormik.values.iv_tariff_description = ''
      mrcFormik.values.iv_tariff_code = ''
      setBillMonthForImages('')
      //single phase readings
      mrcFormik.values.iv_previous_reading_single_phase = ''
      mrcFormik.values.iv_current_reading_single_phase = ''
      mrcFormik.values.iv_claimed_reading_single_phase = ''

      //3 phase readings
      mrcFormik.values.iv_previous_off_peak_three_phase = ''
      mrcFormik.values.iv_previous_peak_three_phase = ''
      mrcFormik.values.iv_current_off_peak_three_phase = ''
      mrcFormik.values.iv_current_peak_three_phase = ''
      mrcFormik.values.iv_claimed_off_peak_three_phase = ''
      mrcFormik.values.iv_claimed_peak_three_phase = ''

      //3 phase mdi readings
      mrcFormik.values.iv_previous_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi = ''
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi = ''

      //net meter
      mrcFormik.values.iv_previous_offpeak_import = ''
      mrcFormik.values.iv_previous_peak_import = ''
      mrcFormik.values.iv_previous_offpeak_export = ''
      mrcFormik.values.iv_previous_peak_export = ''
      mrcFormik.values.iv_current_offpeak_import = ''
      mrcFormik.values.iv_current_peak_import = ''
      mrcFormik.values.iv_current_offpeak_export = ''
      mrcFormik.values.iv_current_peak_export = ''
      mrcFormik.values.iv_claimed_offpeak_import = ''
      mrcFormik.values.iv_claimed_peak_import = ''
      mrcFormik.values.iv_claimed_offpeak_export = ''
      mrcFormik.values.iv_claimed_peak_export = ''

      mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_previous_kWh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_previous_kWh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_previous_kVArh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_previous_kVArh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_previous_mdi_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_previous_mdi_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi_import = ''
      mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_mdi_off_peak_three_phase_mdi_export = ''
      mrcFormik.values.iv_claimed_mdi_peak_three_phase_mdi_export = ''

      mrcFormik.values.iv_applicant_name = ''
      mrcFormik.values.iv_father_name = ''
      mrcFormik.values.iv_applicant_cnic = ''
      mrcFormik.values.iv_applicant_phone_no = ''
      mrcFormik.values.iv_applicant_email = ''
      mrcFormik.values.iv_applicant_cnic_document_front = null
      mrcFormik.values.iv_applicant_cnic_document_back = null
      setMeterImage1()
      setMeterImage2()
      setMeterImage3()
      setMeterImage4()
      setOffPeakImport()
      setOffPeakExport()
      setPeakImport()
      setPeakExport()
      setOffPeakImportError()
      setOffPeakExportError()
      setPeakImportError()
      setPeakExportError()
      setOffPeakImportThumbnail()
      setOffPeakExportThumbnail()
      setPeakImportThumbnail()
      setPeakExportThumbnail()
      setApplicantCnicDocumentFront()
      setApplicantCnicDocumentBack()
      setApplicantCnicFrontError()
      setApplicantCnicBackError()
      setApplicantCnicDocumentFrontThumbnail()
      setApplicantCnicDocumentBackThumbnail()
      setLastPaidBill()
      setLastBillError()
      setLastPaidBillThumbnail()
      setIsCheckedImagesDoNotMatch(false)
    }
  }, [mrcFormik.values.iv_reference_number])

  useEffect(() => {
    if (referenceNumber && referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      mrcFormik.values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      mrcFormik.values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      mrcFormik.values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);
  //#endregion

  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
              Meter Reading Correction
            </h3>
            <StepProgressBar array={mCStatusBarArray} />
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Applicant's Detail
            </Typography>
            <CustomerInformationCard
              searchBy={mrcFormik.values.iv_search_by}
              SearchBy={SearchBy}
              errors={mrcFormik.errors}
              values={mrcFormik.values}
              touched={mrcFormik.touched}
              handleChange={mrcFormik.handleChange}
              handleBlur={mrcFormik.handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
            />
            {
              connectionType &&
              <Typography variant="h6" className="groupTitle">
                <div className="cyanCell">
                </div>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                  <span>
                    Meter Reading Detail
                  </span>
                  <span style={{ backgroundColor: '#006ad1', color: 'white', padding: '2px 5px', borderRadius: '5px' }}>
                    Meter Serial No: {mrcFormik.values.iv_meter_no}
                  </span>
                </div>
              </Typography>
            }
            {
              connectionType && connectionType == '1 phase meter' &&
              <Grid container className='container'>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image</Typography>
                  <img src={meterImage1} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_reading_single_phase"
                      value={mrcFormik.values.iv_current_reading_single_phase}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_reading_single_phase"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_reading_single_phase && mrcFormik.touched.iv_current_reading_single_phase ? (mrcFormik.errors.iv_current_reading_single_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Claimed Image</Typography>
                  <img src={offPeakImportThumbnail ? offPeakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import ? (mrcFormik.errors.iv_off_peak_import) : null}
                    {offPeakImportError ? offPeakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" ref={fileInputRefOffPeakImport} onChange={OffPeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed Reading</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_reading_single_phase"
                      value={mrcFormik.values.iv_claimed_reading_single_phase}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_reading_single_phase"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_reading_single_phase && mrcFormik.touched.iv_claimed_reading_single_phase ? (mrcFormik.errors.iv_claimed_reading_single_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '50px' }}>
                  <div>
                    <Typography className='fieldLabel blueColor' >Reason</Typography>
                    <FormControlLabel
                      sx={{ fontSize: 'small' }}
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesDoNotMatch} onChange={handleChangeImagesDoNotMatch} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Image does not match with current reading.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesAreBlur} onChange={handleChangeImagesAreBlur} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Image is blurred.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedOthers} onChange={handleChangeOthers} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Others.
                        </span>
                      }
                    />
                    {
                      isCheckedOthers ?
                        <>
                          <Typography className='fieldLabel' >Please specify</Typography>
                          <TextField type='text' name='iv_other_remarks' inputProps={{ maxLength: 100 }} id='iv_other_remarks' className='textInputField' value={mrcFormik.values.iv_other_remarks} onChange={mrcFormik.handleChange} onBlur={mrcFormik.handleBlur} />
                          <Box className='from-Error'>
                            {mrcFormik.errors.iv_other_remarks && mrcFormik.touched.iv_other_remarks ? (mrcFormik.errors.iv_other_remarks) : null}
                          </Box>
                        </> :
                        <div style={{ height: '55px', width: 'auto', backgroundColor: 'transparent' }}>
                        </div>

                    }
                  </div>
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_reading_single_phase && (mrcFormik.values.iv_current_reading_single_phase - mrcFormik.values.iv_claimed_reading_single_phase).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                </Grid>
                <Grid item xs={2}>
                  <Typography className='fieldLabel' style={{ color: '#BA3A39' }}>History</Typography>
                  <div style={{ backgroundColor: '#FCEBEB', borderRadius: '5px', fontSize: 'small', textAlign: 'center', padding: '10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Month</th>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Units</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billHistInfo.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistMM}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistUnits}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            }

            {
              connectionType && connectionType == '3 phase meter' &&
              <Grid container className='container'>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image - Off Peak</Typography>
                  <img src={meterImage1} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_off_peak_three_phase"
                      value={mrcFormik.values.iv_current_off_peak_three_phase}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_off_peak_three_phase"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_off_peak_three_phase && mrcFormik.touched.iv_current_off_peak_three_phase ? (mrcFormik.errors.iv_current_off_peak_three_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image - Peak</Typography>
                  <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_peak_three_phase"
                      value={mrcFormik.values.iv_current_peak_three_phase}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_peak_three_phase"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_peak_three_phase && mrcFormik.touched.iv_current_peak_three_phase ? (mrcFormik.errors.iv_current_peak_three_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Claimed Image - Off Peak</Typography>
                  <img src={offPeakImportThumbnail ? offPeakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import ? (mrcFormik.errors.iv_off_peak_import) : null}
                    {offPeakImportError ? offPeakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" ref={fileInputRefOffPeakImport} onChange={OffPeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_off_peak_three_phase"
                      value={mrcFormik.values.iv_claimed_off_peak_three_phase}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_off_peak_three_phase"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_off_peak_three_phase && mrcFormik.touched.iv_claimed_off_peak_three_phase ? (mrcFormik.errors.iv_claimed_off_peak_three_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Claimed Image - Peak</Typography>
                  <img src={peakImportThumbnail ? peakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_import && mrcFormik.touched.iv_peak_import ? (mrcFormik.errors.iv_peak_import) : null}
                    {peakImportError ? peakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_import' name='iv_peak_import' type="file" ref={fileInputRefPeakImport} onChange={PeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed Reading - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_peak_three_phase"
                      value={mrcFormik.values.iv_claimed_peak_three_phase}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_peak_three_phase"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_peak_three_phase && mrcFormik.touched.iv_claimed_peak_three_phase ? (mrcFormik.errors.iv_claimed_peak_three_phase) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <Typography className='fieldLabel' style={{ color: '#BA3A39' }}>History</Typography>
                  <div style={{ backgroundColor: '#FCEBEB', borderRadius: '5px', fontSize: 'small', textAlign: 'center', padding: '10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Month</th>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Units</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billHistInfo.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistMM}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistUnits}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px', marginTop: '15px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                  <Typography className='fieldLabel blueColor' >Reason</Typography>
                  <FormControlLabel

                    control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesDoNotMatch} onChange={handleChangeImagesDoNotMatch} />}
                    label={
                      <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                        Images does not match with current reading.
                      </span>
                    }
                  />
                  <Typography className='fieldLabel' ></Typography>
                  <FormControlLabel
                    control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesAreBlur} onChange={handleChangeImagesAreBlur} />}
                    label={
                      <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                        Images are blurred.
                      </span>
                    }
                  />
                  <Typography className='fieldLabel' ></Typography>
                  <FormControlLabel
                    control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedOthers} onChange={handleChangeOthers} />}
                    label={
                      <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                        Others.
                      </span>
                    }
                  />
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  {
                    isCheckedOthers ?
                      <>
                        <Typography className='fieldLabel' >Please specify</Typography>
                        <TextField type='text' name='iv_other_remarks' id='iv_other_remarks' inputProps={{ maxLength: 100 }} className='textInputField' value={mrcFormik.values.iv_other_remarks} onChange={mrcFormik.handleChange} onBlur={mrcFormik.handleBlur} />
                        <Box className='from-Error'>
                          {mrcFormik.errors.iv_other_remarks && mrcFormik.touched.iv_other_remarks ? (mrcFormik.errors.iv_other_remarks) : null}
                        </Box>
                      </> :
                      <div style={{ height: '55px', width: 'auto', backgroundColor: 'transparent' }}>
                      </div>

                  }
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - Off Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_off_peak_three_phase && (mrcFormik.values.iv_current_off_peak_three_phase - mrcFormik.values.iv_claimed_off_peak_three_phase).toFixed(2)}
                          className='textInputFieldHighlighted'
                          style={{ ...inputStyle }}
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '0px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_peak_three_phase && (mrcFormik.values.iv_current_peak_three_phase - mrcFormik.values.iv_claimed_peak_three_phase).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_off_peak_three_phase && mrcFormik.values.iv_claimed_peak_three_phase) && (
                            (mrcFormik.values.iv_current_off_peak_three_phase ? mrcFormik.values.iv_current_off_peak_three_phase - mrcFormik.values.iv_claimed_off_peak_three_phase : 0) +
                            (mrcFormik.values.iv_current_peak_three_phase ? mrcFormik.values.iv_current_peak_three_phase - mrcFormik.values.iv_claimed_peak_three_phase : 0)
                          ).toFixed(2)}
                          style={{ ...inputStyle, width: '70%' }}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            }

            {
              connectionType && connectionType == 'net meter' &&
              <Grid container className='container'>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image - Off Peak <span style={{ color: '#E97939' }}> Import</span></Typography>
                  <img src={meterImage1} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Off Peak <span style={{ color: '#E97939' }}> Import</span></Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_offpeak_import"
                      value={mrcFormik.values.iv_current_offpeak_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_offpeak_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_offpeak_import && mrcFormik.touched.iv_current_offpeak_import ? (mrcFormik.errors.iv_current_offpeak_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image - Peak <span style={{ color: '#E97939' }}> Import</span></Typography>
                  <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Peak <span style={{ color: '#E97939' }}> Import</span></Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_peak_import"
                      value={mrcFormik.values.iv_current_peak_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_peak_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_peak_import && mrcFormik.touched.iv_current_peak_import ? (mrcFormik.errors.iv_current_peak_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image : Off Peak  <span style={{ color: '#019760' }}> Export</span></Typography>
                  <img src={meterImage3} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Off Peak <span style={{ color: '#019760' }}> Export</span></Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_offpeak_export"
                      value={mrcFormik.values.iv_current_offpeak_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_offpeak_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_offpeak_export && mrcFormik.touched.iv_current_offpeak_export ? (mrcFormik.errors.iv_current_offpeak_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reading Image : Peak <span style={{ color: '#019760' }}> Export</span></Typography>
                  <img src={meterImage4} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Reading - Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_peak_export"
                      value={mrcFormik.values.iv_current_peak_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_peak_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_peak_export && mrcFormik.touched.iv_current_peak_export ? (mrcFormik.errors.iv_current_peak_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <Typography className='fieldLabel' style={{ color: '#BA3A39' }}>History</Typography>
                  <div style={{ backgroundColor: '#FCEBEB', borderRadius: '5px', fontSize: 'small', textAlign: 'center', padding: '10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Month</th>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Units</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billHistInfo.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistMM}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistUnits}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
                {
                  (connectionType === '3 phase mdi meter' || connectionType === 'net meter') &&
                  <>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <Typography className='fieldLabel' >Claimed Image - Off Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                      <img src={offPeakImportThumbnail ? offPeakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakImport} />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import ? (mrcFormik.errors.iv_off_peak_import) : null}
                        {offPeakImportError ? offPeakImportError : null}
                      </Box>
                      <input hidden accept={imageExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" ref={fileInputRefOffPeakImport} onChange={OffPeakImport} />
                      <div style={{ marginTop: '15px' }}>
                        <Typography className='fieldLabel' >Claimed Reading - Off Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                        <TextField
                          required
                          type='number'
                          name="iv_claimed_offpeak_import"
                          value={mrcFormik.values.iv_claimed_offpeak_import}
                          autoComplete='off'
                          onChange={(e) => { mrcFormik.handleChange(e); }}
                          onBlur={mrcFormik.handleBlur}
                          id="iv_claimed_offpeak_import"
                          className='textInputField'
                        />
                        <Box className='from-Error'>
                          {mrcFormik.errors.iv_claimed_offpeak_import && mrcFormik.touched.iv_claimed_offpeak_import ? (mrcFormik.errors.iv_claimed_offpeak_import) : null}
                        </Box>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <Typography className='fieldLabel' >Claimed Image - Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                      <img src={peakImportThumbnail ? peakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakImport} />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_peak_import && mrcFormik.touched.iv_peak_import ? (mrcFormik.errors.iv_peak_import) : null}
                        {peakImportError ? peakImportError : null}
                      </Box>
                      <input hidden accept={imageExtensions} id='iv_peak_import' name='iv_peak_import' type="file" ref={fileInputRefPeakImport} onChange={PeakImport} />
                      <div style={{ marginTop: '15px' }}>
                        <Typography className='fieldLabel' >Claimed Reading - Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                        <TextField
                          required
                          type='number'
                          name="iv_claimed_peak_import"
                          value={mrcFormik.values.iv_claimed_peak_import}
                          autoComplete='off'
                          onChange={(e) => { mrcFormik.handleChange(e); }}
                          onBlur={mrcFormik.handleBlur}
                          id="iv_claimed_peak_import"
                          className='textInputField'
                        />
                        <Box className='from-Error'>
                          {mrcFormik.errors.iv_claimed_peak_import && mrcFormik.touched.iv_claimed_peak_import ? (mrcFormik.errors.iv_claimed_peak_import) : null}
                        </Box>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <Typography className='fieldLabel' >Claimed Image - Off Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                      <img src={offPeakExportThumbnail ? offPeakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakExport} />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export ? (mrcFormik.errors.iv_off_peak_export) : null}
                        {offPeakExportError ? offPeakExportError : null}
                      </Box>
                      <input hidden accept={imageExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" ref={fileInputRefOffPeakExport} onChange={OffPeakExport} />
                      <div style={{ marginTop: '15px' }}>
                        <Typography className='fieldLabel' >Claimed Reading - Off Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                        <TextField
                          required
                          type='number'
                          name="iv_claimed_offpeak_export"
                          value={mrcFormik.values.iv_claimed_offpeak_export}
                          autoComplete='off'
                          onChange={(e) => { mrcFormik.handleChange(e); }}
                          onBlur={mrcFormik.handleBlur}
                          id="iv_claimed_offpeak_export"
                          className='textInputField'
                        />
                        <Box className='from-Error'>
                          {mrcFormik.errors.iv_claimed_offpeak_export && mrcFormik.touched.iv_claimed_offpeak_export ? (mrcFormik.errors.iv_claimed_offpeak_export) : null}
                        </Box>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <Typography className='fieldLabel' >Claimed Image - Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                      <img src={peakExportThumbnail ? peakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakExport} />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_peak_export && mrcFormik.touched.iv_peak_export ? (mrcFormik.errors.iv_peak_export) : null}
                        {peakExportError ? peakExportError : null}
                      </Box>
                      <input hidden accept={imageExtensions} id='iv_peak_export' name='iv_peak_export' type="file" ref={fileInputRefPeakExport} onChange={PeakExport} />
                      <div style={{ marginTop: '15px' }}>
                        <Typography className='fieldLabel' >Claimed Reading - Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                        <TextField
                          required
                          type='number'
                          name="iv_claimed_peak_export"
                          value={mrcFormik.values.iv_claimed_peak_export}
                          autoComplete='off'
                          onChange={(e) => { mrcFormik.handleChange(e); }}
                          onBlur={mrcFormik.handleBlur}
                          id="iv_claimed_peak_export"
                          className='textInputField'
                        />
                        <Box className='from-Error'>
                          {mrcFormik.errors.iv_claimed_peak_export && mrcFormik.touched.iv_claimed_peak_export ? (mrcFormik.errors.iv_claimed_peak_export) : null}
                        </Box>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel blueColor'>Reason</Typography>
                        <FormControlLabel
                          control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesDoNotMatch} onChange={handleChangeImagesDoNotMatch} />}
                          label={
                            <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                              Images does not match with current reading.
                            </span>
                          }
                        />
                        <Typography className='fieldLabel' ></Typography>
                        <FormControlLabel
                          control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesAreBlur} onChange={handleChangeImagesAreBlur} />}
                          label={
                            <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                              Images are blurred.
                            </span>
                          }
                        />
                        <Typography className='fieldLabel' ></Typography>
                        <FormControlLabel
                          control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedOthers} onChange={handleChangeOthers} />}
                          label={
                            <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                              Others
                            </span>
                          }
                        />
                        {
                          isCheckedOthers ?
                            <>
                              <Typography className='fieldLabel' >Please specify</Typography>
                              <TextField type='text' name='iv_other_remarks' id='iv_other_remarks' inputProps={{ maxLength: 100 }} className='textInputField' value={mrcFormik.values.iv_other_remarks} onChange={mrcFormik.handleChange} onBlur={mrcFormik.handleBlur} />
                              <Box className='from-Error'>
                                {mrcFormik.errors.iv_other_remarks && mrcFormik.touched.iv_other_remarks ? (mrcFormik.errors.iv_other_remarks) : null}
                              </Box>
                            </> :
                            <div style={{ height: '55px', width: 'auto', backgroundColor: 'transparent' }}>
                            </div>

                        }
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Difference - Off Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={mrcFormik.values.iv_claimed_offpeak_import && (mrcFormik.values.iv_current_offpeak_import - mrcFormik.values.iv_claimed_offpeak_import).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Difference - Peak <span style={{ color: '#E97939' }}>Import</span></Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={mrcFormik.values.iv_claimed_peak_import && (mrcFormik.values.iv_current_peak_import - mrcFormik.values.iv_claimed_peak_import).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Difference - Off Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={mrcFormik.values.iv_claimed_offpeak_export && (mrcFormik.values.iv_current_offpeak_export - mrcFormik.values.iv_claimed_offpeak_export).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Difference - Peak <span style={{ color: '#019760' }}>Export</span></Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={mrcFormik.values.iv_claimed_peak_export && (mrcFormik.values.iv_current_peak_export - mrcFormik.values.iv_claimed_peak_export).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={2.4} sx={{ marginTop: '15px' }}></Grid>
                    <Grid item xs={4.8} sx={{ marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Total Import Difference</Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={(mrcFormik.values.iv_claimed_offpeak_import && mrcFormik.values.iv_claimed_peak_import) && (
                                (mrcFormik.values.iv_current_offpeak_import ? mrcFormik.values.iv_current_offpeak_import - mrcFormik.values.iv_claimed_offpeak_import : 0) +
                                (mrcFormik.values.iv_current_peak_import ? mrcFormik.values.iv_current_peak_import - mrcFormik.values.iv_claimed_peak_import : 0)
                              ).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={4.8} sx={{ marginTop: '15px' }}>
                      <div>
                        <Typography className='fieldLabel' >Total Export Difference</Typography>
                        <div>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                              type='text'
                              disabled
                              value={(mrcFormik.values.iv_claimed_offpeak_export && mrcFormik.values.iv_claimed_peak_export) && (
                                (mrcFormik.values.iv_current_offpeak_export ? mrcFormik.values.iv_current_offpeak_export - mrcFormik.values.iv_claimed_offpeak_export : 0) +
                                (mrcFormik.values.iv_current_peak_export ? mrcFormik.values.iv_current_peak_export - mrcFormik.values.iv_claimed_peak_export : 0)
                              ).toFixed(2)}
                              style={inputStyle}
                              className='textInputFieldHighlighted'
                            />
                            <div style={adornmentStyle}>
                              Units
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </>
                }
              </Grid>
            }

            {
              connectionType && connectionType == '3 phase mdi meter' &&
              <Grid container className='container'>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image - Off Peak</Typography>
                  <img src={meterImage1} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kWh Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kwh_off_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kwh_off_peak_three_phase_mdi"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kwh_off_peak_three_phase_mdi && mrcFormik.touched.iv_current_kwh_off_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_kwh_off_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image - Peak</Typography>
                  <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kwh Reading - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kwh_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_current_kwh_peak_three_phase_mdi}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kwh_peak_three_phase_mdi"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kwh_peak_three_phase_mdi && mrcFormik.touched.iv_current_kwh_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_kwh_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kVArh Reading Image : Off Peak</Typography>
                  <img src={meterImage3} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_off_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_off_peak_three_phase_mdi"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi && mrcFormik.touched.iv_current_kVArh_off_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kVArh Reading Image : Peak</Typography>
                  <img src={meterImage4} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_peak_three_phase_mdi"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi && mrcFormik.touched.iv_current_kVArh_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <Typography className='fieldLabel' style={{ color: '#BA3A39' }}>History</Typography>
                  <div style={{ backgroundColor: '#FCEBEB', borderRadius: '5px', fontSize: 'small', textAlign: 'center', padding: '10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Month</th>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Units</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billHistInfo.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistMM}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistUnits}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item lg={2.5} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel' >MDI Reading - Off Peak</Typography>
                      <TextField
                        required
                        type='text'
                        name="iv_current_mdi_off_peak_three_phase_mdi"
                        value={mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi}
                        disabled
                        autoComplete='off'
                        onChange={mrcFormik.handleChange}
                        onBlur={mrcFormik.handleBlur}
                        id="iv_current_mdi_off_peak_three_phase_mdi"
                        className='textInputField1'
                        style={{ width: '100%' }}
                      />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi && mrcFormik.touched.iv_current_mdi_off_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi) : null}
                      </Box>
                    </Grid>
                    <Grid item lg={2.5} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel' >MDI Reading - Peak</Typography>
                      <TextField
                        required
                        type='text'
                        name="iv_current_mdi_peak_three_phase_mdi"
                        value={mrcFormik.values.iv_current_mdi_peak_three_phase_mdi}
                        disabled
                        autoComplete='off'
                        onChange={mrcFormik.handleChange}
                        onBlur={mrcFormik.handleBlur}
                        id="iv_current_mdi_peak_three_phase_mdi"
                        className='textInputField1'
                      />
                      <Box className='from-Error'>
                        {mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi && mrcFormik.touched.iv_current_mdi_peak_three_phase_mdi ? (mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi) : null}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image - Off Peak</Typography>
                  <img src={offPeakImportThumbnail ? offPeakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import ? (mrcFormik.errors.iv_off_peak_import) : null}
                    {offPeakImportError ? offPeakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" ref={fileInputRefOffPeakImport} onChange={OffPeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kwh_off_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kwh_off_peak_three_phase_mdi"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kwh_off_peak_three_phase_mdi && mrcFormik.touched.iv_claimed_kwh_off_peak_three_phase_mdi ? (mrcFormik.errors.iv_claimed_kwh_off_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image - Peak</Typography>
                  <img src={peakImportThumbnail ? peakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_import && mrcFormik.touched.iv_peak_import ? (mrcFormik.errors.iv_peak_import) : null}
                    {peakImportError ? peakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_import' name='iv_peak_import' type="file" ref={fileInputRefPeakImport} onChange={PeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kwh_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kwh_peak_three_phase_mdi"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kwh_peak_three_phase_mdi && mrcFormik.touched.iv_claimed_kwh_peak_three_phase_mdi ? (mrcFormik.errors.iv_claimed_kwh_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kVArh Image - Off Peak</Typography>
                  <img src={offPeakExportThumbnail ? offPeakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export ? (mrcFormik.errors.iv_off_peak_export) : null}
                    {offPeakExportError ? offPeakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" ref={fileInputRefOffPeakExport} onChange={OffPeakExport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_off_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_off_peak_three_phase_mdi"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi && mrcFormik.touched.iv_claimed_kVArh_off_peak_three_phase_mdi ? (mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kVArh Image - Peak </Typography>
                  <img src={peakExportThumbnail ? peakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_export && mrcFormik.touched.iv_peak_export ? (mrcFormik.errors.iv_peak_export) : null}
                    {peakExportError ? peakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_export' name='iv_peak_export' type="file" ref={fileInputRefPeakExport} onChange={PeakExport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_peak_three_phase_mdi"
                      value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_peak_three_phase_mdi"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi && mrcFormik.touched.iv_claimed_kVArh_peak_three_phase_mdi ? (mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel blueColor'>Reason</Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesDoNotMatch} onChange={handleChangeImagesDoNotMatch} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Images does not match with current reading.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesAreBlur} onChange={handleChangeImagesAreBlur} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Images are blurred.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedOthers} onChange={handleChangeOthers} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Others
                        </span>
                      }
                    />
                    {
                      isCheckedOthers ?
                        <>
                          <Typography className='fieldLabel' >Please specify</Typography>
                          <TextField type='text' name='iv_other_remarks' id='iv_other_remarks' inputProps={{ maxLength: 100 }} className='textInputField' value={mrcFormik.values.iv_other_remarks} onChange={mrcFormik.handleChange} onBlur={mrcFormik.handleBlur} />
                          <Box className='from-Error'>
                            {mrcFormik.errors.iv_other_remarks && mrcFormik.touched.iv_other_remarks ? (mrcFormik.errors.iv_other_remarks) : null}
                          </Box>
                        </> :
                        <div style={{ height: '55px', width: 'auto', backgroundColor: 'transparent' }}>
                        </div>

                    }
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Off Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi && (mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi && (mrcFormik.values.iv_current_kwh_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Off Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi && (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Peak</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi && (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item sx={2.4} sx={{ marginTop: '15px' }}>
                </Grid>
                <Grid item xs={4.8} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kWh Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi && mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi) && (
                            (mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi ? mrcFormik.values.iv_current_kwh_off_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kwh_off_peak_three_phase_mdi : 0) +
                            (mrcFormik.values.iv_current_kwh_peak_three_phase_mdi ? mrcFormik.values.iv_current_kwh_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kwh_peak_three_phase_mdi : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={4.8} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kVArh Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi && mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi) && (
                            (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi ? mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi : 0) +
                            (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi ? mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            }

            {
              connectionType && connectionType == '3 phase mdi net meter' &&
              <Grid container className='container'>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image (Import) - Off Peak</Typography>
                  <img src={meterImage1} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kWh Reading (Import) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kWh_off_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import} // to be updated from here
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kWh_off_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kWh_off_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_kWh_off_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_kWh_off_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image (Import) - Peak</Typography>
                  <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kWh Reading (Import) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kWh_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kWh_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kWh_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_kWh_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_kWh_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image (Export) - Off Peak</Typography>
                  <img src={meterImage3} alt='meter 1' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kWh Reading (Export) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kWh_off_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kWh_off_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kWh_off_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_kWh_off_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_kWh_off_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >kWh Reading Image (Export) - Peak</Typography>
                  <img src={meterImage4} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kwh Reading (Export) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kWh_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kWh_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kWh_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_kWh_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_kWh_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>

                {/* History */}
                <Grid item xs={2.4}>
                  <Typography className='fieldLabel' style={{ color: '#BA3A39' }}>History</Typography>
                  <div style={{ backgroundColor: '#FCEBEB', borderRadius: '5px', fontSize: 'small', textAlign: 'center', padding: '10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Month</th>
                          <th style={{ textAlign: 'center', padding: '0px 0px 10px 0px' }}>Units</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billHistInfo.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistMM}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.gbHistUnits}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Import) - Off Peak</Typography> */}
                  {/* <img src={meterImage3} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading (Import) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_off_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_off_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_kVArh_off_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Import) - Peak</Typography> */}
                  {/* <img src={meterImage4} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading (Import) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_kVArh_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Export) - Off Peak</Typography> */}
                  {/* <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading (Export) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_off_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_off_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_kVArh_off_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_kVArh_off_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Export) - Peak</Typography> */}
                  {/* <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >kVArh Reading (Exort) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_kVArh_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_kVArh_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_kVArh_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_kVArh_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}></Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >MDI Reading Image (Import) - Off Peak</Typography> */}
                  {/* <img src={meterImage3} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >MDI Reading (Import) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_mdi_off_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_mdi_off_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_mdi_off_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Import) - Peak</Typography> */}
                  {/* <img src={meterImage4} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >MDI Reading (Import) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_mdi_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_import}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_mdi_peak_three_phase_mdi_import"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi_import && mrcFormik.touched.iv_current_mdi_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Export) - Off Peak</Typography> */}
                  {/* <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >MDI Reading (Export) - Off Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_mdi_off_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_mdi_off_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_mdi_off_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_mdi_off_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_mdi_off_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}>
                  {/* <Typography className='fieldLabel' >kVArh Reading Image (Export) - Peak</Typography> */}
                  {/* <img src={meterImage2} alt='meter 2' width={'100%'} height={200} style={{ borderRadius: '5px' }}
                    onError={(e) => {
                      e.target.src = 'https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6-300x188.png';
                    }} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >MDI Reading (Exort) - Peak</Typography>
                    <TextField
                      required
                      type='text'
                      name="iv_current_mdi_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_current_mdi_peak_three_phase_mdi_export}
                      disabled
                      autoComplete='off'
                      onChange={mrcFormik.handleChange}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_current_mdi_peak_three_phase_mdi_export"
                      className='textInputField1'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi_export && mrcFormik.touched.iv_current_mdi_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_current_mdi_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px' }}></Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image (Import) - Off Peak</Typography>
                  <img src={offPeakImportThumbnail ? offPeakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import ? (mrcFormik.errors.iv_off_peak_import) : null}
                    {offPeakImportError ? offPeakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" ref={fileInputRefOffPeakImport} onChange={OffPeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading (Import) - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kWh_off_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kWh_off_peak_three_phase_mdi_import"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kWh_off_peak_three_phase_mdi_import && mrcFormik.touched.iv_claimed_kWh_off_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_claimed_kWh_off_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image (Import) - Peak</Typography>
                  <img src={peakImportThumbnail ? peakImportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakImport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_import && mrcFormik.touched.iv_peak_import ? (mrcFormik.errors.iv_peak_import) : null}
                    {peakImportError ? peakImportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_import' name='iv_peak_import' type="file" ref={fileInputRefPeakImport} onChange={PeakImport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading (Import) - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kWh_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kWh_peak_three_phase_mdi_import"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kWh_peak_three_phase_mdi_import && mrcFormik.touched.iv_claimed_kWh_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_claimed_kWh_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image (Export) - Off Peak</Typography>
                  <img src={offPeakExportThumbnail ? offPeakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export ? (mrcFormik.errors.iv_off_peak_export) : null}
                    {offPeakExportError ? offPeakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" ref={fileInputRefOffPeakExport} onChange={OffPeakExport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading (Export) - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kWh_off_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kWh_off_peak_three_phase_mdi_export"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kWh_off_peak_three_phase_mdi_export && mrcFormik.touched.iv_claimed_kWh_off_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_claimed_kWh_off_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <Typography className='fieldLabel' >Claimed kWh Image (Export) - Peak</Typography>
                  <img src={peakExportThumbnail ? peakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_export && mrcFormik.touched.iv_peak_export ? (mrcFormik.errors.iv_peak_export) : null}
                    {peakExportError ? peakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_export' name='iv_peak_export' type="file" ref={fileInputRefPeakExport} onChange={PeakExport} />
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kWh Reading (Export) - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kWh_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kWh_peak_three_phase_mdi_export"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kWh_peak_three_phase_mdi_export && mrcFormik.touched.iv_claimed_kWh_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_claimed_kWh_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ marginTop: '15px' }}></Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  {/* <Typography className='fieldLabel' >Claimed kVArh Image (Import) - Off Peak</Typography> */}
                  {/* <img src={offPeakExportThumbnail ? offPeakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export ? (mrcFormik.errors.iv_off_peak_export) : null}
                    {offPeakExportError ? offPeakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" ref={fileInputRefOffPeakExport} onChange={OffPeakExport} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading (Import) - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_off_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_off_peak_three_phase_mdi_import"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi_import && mrcFormik.touched.iv_claimed_kVArh_off_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  {/* <Typography className='fieldLabel' >Claimed kVArh Image (Import) - Peak </Typography>
                  <img src={peakExportThumbnail ? peakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_export && mrcFormik.touched.iv_peak_export ? (mrcFormik.errors.iv_peak_export) : null}
                    {peakExportError ? peakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_export' name='iv_peak_export' type="file" ref={fileInputRefPeakExport} onChange={PeakExport} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading (Import) - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_peak_three_phase_mdi_import"
                      value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_peak_three_phase_mdi_import"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi_import && mrcFormik.touched.iv_claimed_kVArh_peak_three_phase_mdi_import ? (mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi_import) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  {/* <Typography className='fieldLabel' >Claimed kVArh Image (Export) - Off Peak</Typography>
                  <img src={offPeakExportThumbnail ? offPeakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={OffPeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export ? (mrcFormik.errors.iv_off_peak_export) : null}
                    {offPeakExportError ? offPeakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" ref={fileInputRefOffPeakExport} onChange={OffPeakExport} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading (Export) - Off Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_off_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_off_peak_three_phase_mdi_export"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi_export && mrcFormik.touched.iv_claimed_kVArh_off_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_claimed_kVArh_off_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  {/* <Typography className='fieldLabel' >Claimed kVArh Image (Export) - Peak </Typography>
                  <img src={peakExportThumbnail ? peakExportThumbnail : UploadSampleImage} alt='SampleUpload' width={'100%'} height={200} style={{ borderRadius: '5px' }} onClick={PeakExport} />
                  <Box className='from-Error'>
                    {mrcFormik.errors.iv_peak_export && mrcFormik.touched.iv_peak_export ? (mrcFormik.errors.iv_peak_export) : null}
                    {peakExportError ? peakExportError : null}
                  </Box>
                  <input hidden accept={imageExtensions} id='iv_peak_export' name='iv_peak_export' type="file" ref={fileInputRefPeakExport} onChange={PeakExport} /> */}
                  <div style={{ marginTop: '15px' }}>
                    <Typography className='fieldLabel' >Claimed kVArh Reading (Export) - Peak</Typography>
                    <TextField
                      required
                      type='number'
                      name="iv_claimed_kVArh_peak_three_phase_mdi_export"
                      value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export}
                      autoComplete='off'
                      onChange={(e) => { mrcFormik.handleChange(e); }}
                      onBlur={mrcFormik.handleBlur}
                      id="iv_claimed_kVArh_peak_three_phase_mdi_export"
                      className='textInputField'
                    />
                    <Box className='from-Error'>
                      {mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi_export && mrcFormik.touched.iv_claimed_kVArh_peak_three_phase_mdi_export ? (mrcFormik.errors.iv_claimed_kVArh_peak_three_phase_mdi_export) : null}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}></Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Off Peak Import</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import && (mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Peak Import</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import && (mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Off Peak Export</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export && (mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kWh Peak Export</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export && (mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}></Grid>

                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Off Peak Import</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import && (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Peak Import</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import && (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Off Peak Export</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export && (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Difference - kVArh Peak Export</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export && (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item sx={2.4} sx={{ paddingRight: '20px', marginTop: '15px' }}></Grid>

                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kWh Import Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import && mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import) && (
                            (mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import ? mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_import : 0) +
                            (mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import ? mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_import : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kWh Export Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export && mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export) && (
                            (mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export ? mrcFormik.values.iv_current_kWh_off_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kWh_off_peak_three_phase_mdi_export : 0) +
                            (mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export ? mrcFormik.values.iv_current_kWh_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kWh_peak_three_phase_mdi_export : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kVArh Import Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import && mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import) && (
                            (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import ? mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_import : 0) +
                            (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import ? mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_import - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_import : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel' >Total kVArh Export Difference</Typography>
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <input
                          type='text'
                          disabled
                          value={(mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export && mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export) && (
                            (mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export ? mrcFormik.values.iv_current_kVArh_off_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kVArh_off_peak_three_phase_mdi_export : 0) +
                            (mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export ? mrcFormik.values.iv_current_kVArh_peak_three_phase_mdi_export - mrcFormik.values.iv_claimed_kVArh_peak_three_phase_mdi_export : 0)
                          ).toFixed(2)}
                          style={inputStyle}
                          className='textInputFieldHighlighted'
                        />
                        <div style={adornmentStyle}>
                          Units
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2.4} sx={{ marginTop: '15px' }}>
                  <div>
                    <Typography className='fieldLabel blueColor'>Reason</Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesDoNotMatch} onChange={handleChangeImagesDoNotMatch} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Images does not match with current reading.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedImagesAreBlur} onChange={handleChangeImagesAreBlur} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Images are blurred.
                        </span>
                      }
                    />
                    <Typography className='fieldLabel' ></Typography>
                    <FormControlLabel
                      control={<Checkbox style={{ marginBottom: '-10px' }} checked={isCheckedOthers} onChange={handleChangeOthers} />}
                      label={
                        <span style={{ fontSize: '12px' }}>  {/* Adjust font size here */}
                          Others
                        </span>
                      }
                    />
                    {
                      isCheckedOthers ?
                        <>
                          <Typography className='fieldLabel' >Please specify</Typography>
                          <TextField type='text' name='iv_other_remarks' id='iv_other_remarks' inputProps={{ maxLength: 100 }} className='textInputField' value={mrcFormik.values.iv_other_remarks} onChange={mrcFormik.handleChange} onBlur={mrcFormik.handleBlur} />
                          <Box className='from-Error'>
                            {mrcFormik.errors.iv_other_remarks && mrcFormik.touched.iv_other_remarks ? (mrcFormik.errors.iv_other_remarks) : null}
                          </Box>
                        </> :
                        <div style={{ height: '55px', width: 'auto', backgroundColor: 'transparent' }}>
                        </div>

                    }
                  </div>
                </Grid>
              </Grid>
            }

            {/* <Typography variant="h6" className="groupTitleDocuments">
              Required Documents
            </Typography> */}
            {/* <Grid container spacing={1} className="documentsContainer"> */}
            {/* <Grid item lg="1.25">
                <Typography className="documentLabel">
                  1- Applicant's CNIC.
                  <span style={{ color: "#A1A1A1", marginLeft: "3%" }}>
                    (Optional)
                  </span>
                </Typography>
                <Box className="documentError">
                  {mrcFormik.errors.iv_applicant_cnic_document_front &&
                    mrcFormik.touched.iv_applicant_cnic_document_front
                    ? mrcFormik.errors.iv_applicant_cnic_document_front
                    : null}
                </Box>
                <Box className="documentError">
                  {mrcFormik.errors.iv_applicant_cnic_document_back &&
                    mrcFormik.touched.iv_applicant_cnic_document_back
                    ? mrcFormik.errors.iv_applicant_cnic_document_back
                    : null}
                </Box>
              </Grid> */}
            {/* <Grid item lg=".875">
                {applicantCnicDocumentFront ? (
                  <>
                    <Button
                      varient="outlined"
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentFront("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentFrontThumbnail &&
                        isImage(applicantCnicDocumentFront) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentFrontThumbnail}
                            alt="Applicant CNIC Front"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentFront) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Front
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_front"
                        name="iv_applicant_cnic_document_front"
                        type="file"
                        onChange={ApplicantCnicDocumentFront}
                      />
                    </Button>
                    <Box className="documentError">
                      {applicantCnicDocumentFront == '' ?
                        applicantCnicFrontError : null
                      }
                    </Box>
                  </>
                )}
              </Grid> */}
            {/* <Grid item lg=".875">
                {applicantCnicDocumentBack ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentBack("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentBackThumbnail &&
                        isImage(applicantCnicDocumentBack) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentBackThumbnail}
                            alt="Applicant CNIC Back"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentBack) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Back
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_back"
                        name="iv_applicant_cnic_document_back"
                        type="file"
                        onChange={ApplicantCnicDocumentBack}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        applicantCnicDocumentBack == '' ?
                          applicantCnicBackError : null
                      }
                    </Box>
                  </>
                )}
              </Grid> */}
            {/* <Grid item lg={2} >
                <Typography className='documentLabel' >2- Copy of Bill</Typography>
                <Box className='documentError'>{mrcFormik.errors.iv_last_paid_bill && mrcFormik.touched.iv_last_paid_bill ? (mrcFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
              </Grid> */}
            {/* <Grid item lg={2}>
                {
                  lastPaidBill ?
                    <>
                      <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                        {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                          <div className='btn-div'>
                            <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                          </div>
                        ) : (
                          <span>{isPdf(lastPaidBill) ?
                            <div className='btn-div'>
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                            : "Other file type"}</span>
                        )}
                      </Button>
                    </>
                    :
                    <>
                      <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                        Upload
                        <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                      </Button>
                    </>
                }
              </Grid> */}
            {/* </Grid> */}
            {
              error &&
              <Error
                error={error}
                onClose={() => errorCloses()}
                backgroundColor="#FFC0CB"
                textColor="#bb0303"
                iconColor="#bb0303"
              />
            }
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button
                className={((mrcFormik.values.iv_consumer_id.length != 10 || mrcFormik.values.iv_reference_number.length != 14) && mrcFormik.values.iv_applicant_phone_no != '') === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" disabled={((mrcFormik.values.iv_consumer_id.length != 10 || mrcFormik.values.iv_reference_number.length != 14) && mrcFormik.values.iv_applicant_phone_no != '') === false} type='submit' onClick={() => { mrcFormik.handleSubmit(); }}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      <FormSubmissionSuccessDialog
        open={meterReadingPopUp}
        onClose={handleClose}
        title="Request submitted"
        message="Your Meter Reading Correction complaint is submitted successfully."
        trackingId={complaintId}
        trackingLabel="Complaint ID"
      />

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  );
}

export default MeterReadingCorrectionForm;